var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReducedOperationalDelays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 167,
    viewBox: "0 0 167 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_534_32633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.452 43.6969V43.7207H115.595C112.756 43.7207 110.429 41.3938 110.429 38.5531C110.429 35.7125 112.756 33.3856 115.595 33.3856H141.286H142.536V32.1356V6.41757C142.536 3.5769 144.863 1.25 147.702 1.25C150.542 1.25 152.869 3.5769 152.869 6.41757V38.5293C152.869 41.37 150.542 43.6969 147.702 43.6969H146.452Z",
    fill: "#A52EB1",
    stroke: "white",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2789 165.75H83.4881C61.5396 165.75 40.8911 157.221 25.3592 141.64L25.3565 141.637C9.77765 126.103 1.25 105.452 1.25 83.5C1.25 61.5482 9.77765 40.8967 25.3565 25.3626L25.3592 25.3599C40.8911 9.7788 61.5396 1.25 83.4881 1.25C110.487 1.25 136.723 14.4065 151.887 35.5131L151.891 35.5189C153.574 37.8329 153.03 41.0593 150.694 42.7391L150.688 42.7431C148.375 44.4259 145.149 43.8816 143.47 41.5454C130.175 23.0463 107.198 11.609 83.4642 11.609C43.8205 11.609 11.5595 43.875 11.5595 83.5239C11.5595 123.173 43.8205 155.439 83.4642 155.439C123.108 155.439 155.369 123.173 155.369 83.5239C155.369 77.4565 154.617 71.4114 153.111 65.5582L153.109 65.5507C152.383 62.7973 154.064 59.9682 156.839 59.2551L156.847 59.253C159.6 58.5266 162.428 60.2082 163.142 62.9838C164.856 69.6563 165.726 76.5896 165.726 83.5477C165.726 105.499 157.198 126.151 141.62 141.685L141.618 141.686C126.733 156.574 107.186 165.046 86.2789 165.75Z",
    fill: "#A52EB1",
    stroke: "white",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.595 88.6675H96.3214C93.4816 88.6675 91.1548 86.3406 91.1548 83.5C91.1548 80.6593 93.4816 78.3324 96.3214 78.3324H115.595C118.435 78.3324 120.762 80.6593 120.762 83.5C120.762 86.3406 118.435 88.6675 115.595 88.6675Z",
    fill: "#A52EB1",
    stroke: "white",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4879 75.8085H82.9917C80.382 75.5564 78.3213 73.3381 78.3213 70.6648V32.1117C78.3213 29.271 80.6481 26.9441 83.4879 26.9441C86.3278 26.9441 88.6546 29.271 88.6546 32.1117V70.6409C88.6546 73.4816 86.3278 75.8085 83.4879 75.8085Z",
    fill: "#A52EB1",
    stroke: "white",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4882 101.527C73.5399 101.527 65.4644 93.4501 65.4644 83.5C65.4644 73.5499 73.5399 65.4734 83.4882 65.4734C93.4364 65.4734 101.512 73.5499 101.512 83.5C101.512 93.4501 93.4364 101.527 83.4882 101.527ZM83.4882 75.8324C79.2673 75.8324 75.8215 79.2789 75.8215 83.5C75.8215 87.721 79.2673 91.1675 83.4882 91.1675C87.709 91.1675 91.1548 87.721 91.1548 83.5C91.1548 79.2789 87.709 75.8324 83.4882 75.8324Z",
    fill: "#A52EB1",
    stroke: "white",
    strokeWidth: 2.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_534_32633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167,
    height: 167,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReducedOperationalDelays);
export default __webpack_public_path__ + "static/media/reduced-operational-delays.0ae6536f6fa85d605cd4fad628730dbf.svg";
export { ForwardRef as ReactComponent };